import Vue from 'vue/dist/vue.esm.js'
import Router from 'vue-router'
import uuid from 'uuid4'
import QRCodeGenerator from '@/components/QRCodeGenerator'
import List from '@/components/List'
import { dateTimeModules } from './DataConvert'
import {
  SESSION_ID,
  EMP_NO,
  EMAIL,
  NAME,
  LOGIN_FORM_URL
} from './../constants'
// import VueRouter from 'vue-router'

Vue.use(Router)

const routes = [
  // {
  //   path: '/',
  //   name: 'app',
  //   component: App
  // },
  {
    path: '/',
    name: 'QRCodeGenerator',
    component: QRCodeGenerator
  },
  {
    path: '/list',
    name: 'List',
    component: List
  }

]
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach(async (to, from, next) => {
  // クエリパラメータを有無の確認
  if (
    to.query !== undefined &&
            to.query.eno !== undefined &&
            to.query.opt !== undefined &&
            to.query.email !== undefined
  ) {
    // ストレージ格納(期限付きSESSID,empno,email,name)
    setStoroge(to.query.opt, dateTimeModules.dateConvertToDate(to.query.tl))
    var encodedNumber = btoa(to.query.eno)
    var encodedEmail = btoa(to.query.email)
    var encodedName = btoa(encodeURIComponent(to.query.name))
    localStorage.setItem(EMP_NO, encodedNumber)
    localStorage.setItem(EMAIL, encodedEmail)
    localStorage.setItem(NAME, encodedName)
    location.search = ''
            console.log(location);//eslint-disable-line

    // localStorage.setItem(EMP_NO, to.query.eno);
    // localStorage.setItem(EMAIL, to.query.email);
    // localStorage.setItem(NAME, to.query.name);
  }
  // SessionIdの存在確認
  if (getStorage() === undefined) {
    // ログイン認証後のcallbackURLを現在のlocationから取得
    var cdValue = `${location.protocol}//${location.host}`
    // 現在日付を取得
    var tlValue = dateTimeModules.dateConvertToString(new Date())
    // ユニークなIDを生成
    var optValue = uuid()
    // Googleログイン画面(NJC認証サービスサイト)に遷移
    window.location.href = `${LOGIN_FORM_URL}cb=${cdValue}&tl=${tlValue}&opt=${optValue}`
  }
  next()
})

// sessionKeyの値をセットする
const setStoroge = (value, expire) => {
  var data
  expire = new Date()
  // ログイン継続を設定 30日間保持
  expire.setDate(expire.getDate() + 30)
  // 期限日付とSessionIdをセット
  data = {
    expire: dateTimeModules.dateConvertToString(expire),
    value: btoa(value)
  }
  // ストレージ格納
  localStorage.setItem(SESSION_ID, JSON.stringify(data))
}

// sessionKeyの値を取得する
const getStorage = () => {
  var sessionValue = localStorage[SESSION_ID]
  // sessionValueがない場合undefinedを返却
  if (sessionValue === 'undefined' || sessionValue === undefined) {
    return undefined
  }
  sessionValue = JSON.parse(sessionValue)
  // 現在日付が期限日付を過ぎてないか確認
  if (dateTimeModules.dateConvertToDate(sessionValue.expire) > new Date()) {
    return sessionValue.value
  } else {
    // ストレージからSessionIdを削除
    localStorage.removeItem(SESSION_ID)
    return undefined
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js